import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import '@/App.css';
import { EnquiryProvider } from '@/context/EnquiryContext';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { EnquiryPopup, FloatingQuoteButton } from '@/components/EnquiryPopup';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import Home from '@/pages/Home';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import Gallery from '@/pages/Gallery';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Contact from '@/pages/Contact';
import Sustainability from '@/pages/Sustainability';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import Careers from '@/pages/Careers';
import WhyChooseUsPage from '@/pages/WhyChooseUsPage';
import AboutDeveloper from '@/pages/AboutDeveloper';
import Enquiry from '@/pages/Enquiry';
import SocialWorks from '@/pages/SocialWorks';

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <EnquiryProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="grain-overlay" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
          <Route path="/about-developer" element={<AboutDeveloper />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/social-works" element={<SocialWorks />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <FloatingQuoteButton />
        <WhatsAppButton />
        <EnquiryPopup />
      </BrowserRouter>
    </EnquiryProvider>
  );
}

export default App;
